import React from 'react';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { Node } from '@uncinc/react-drupal-core';
import Immutable from 'immutable';
import type { ImmutableEntity, ReferenceField } from '@uncinc/react-drupal-core/types';

import Carousel from '../Carousel';
import type { NodeExpert } from '../../types/nodes';

import './style.scss';

interface ExpertsSliderProps {
  experts: Immutable.List<ImmutableEntity<ReferenceField<NodeExpert>>>,
  expertsTitle: string,
}

const ExpertsSlider: React.FC<ExpertsSliderProps> = ({ experts, expertsTitle }) => {
  if (experts.size === 0) {
    return null;
  }

  if (experts.size === 1) {
    const expert = experts.get(0);
    if (!expert) {
      return null;
    }

    return (
      <div className="Expert__slider">
        <Container>
          <div className="row">
            <div className="col-12 col-lg-8 offset-lg-2">
              <h2 className="Expert__slider__expert__title">{expertsTitle}</h2>
              <Node
                key={expert.get('target_uuid')}
                id={expert.getIn(['entity', 'nid', 0, 'value'])}
                entity={expert.get('entity')}
                viewMode="teaser"
                isCard
              />
            </div>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="Expert__slider">
      <Container>
        <div className="row">
          <div className="col-12 col-lg-8 offset-lg-2">
            <div className="Expert__slider__expert">
              <h2 className="Expert__slider__expert__title">{expertsTitle}</h2>
              <Carousel single>
                {experts.map((expert) => (
                  <Node
                    key={expert.get('target_uuid')}
                    id={expert.getIn(['entity', 'nid', 0, 'value'])}
                    entity={expert.get('entity')}
                    viewMode="teaser"
                    isCard
                  />
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ExpertsSlider;
